import i18n from "../util/i18n.ts";

export const PopText = ({
	className,
	numActiveTeams,
	teams,
	tid,
}: {
	className?: string;
	numActiveTeams: number;
	teams: {
		tid: number;
		pop?: number;
		popRank: number;
	}[];
	tid: number | undefined;
}) => {
	if (tid === undefined) {
		return null;
	}

	if (tid >= 0) {
		const t = teams.find((t2) => t2.tid === tid);
		if (t) {
			const activeTeams = teams;
			const marketRank =
				activeTeams.filter((team) =>
					t.pop !== undefined && team.pop !== undefined
						? team.pop > t.pop
						: team.popRank < t.popRank,
				).length + 1;
			const marketRankTied = activeTeams.some(
				(team) =>
					team.tid !== t.tid &&
					(t.pop !== undefined && team.pop !== undefined
						? team.pop === t.pop
						: team.popRank === t.popRank),
			);
			let size;
			if (t.popRank <= Math.ceil((3 / 30) * numActiveTeams)) {
				size = "very large";
			} else if (t.popRank <= Math.ceil((8 / 30) * numActiveTeams)) {
				size = "large";
			} else if (t.popRank <= Math.ceil((16 / 30) * numActiveTeams)) {
				size = "normal";
			} else if (t.popRank <= Math.ceil((24 / 30) * numActiveTeams)) {
				size = "small";
			} else {
				size = "very small";
			}
			const sizeText = i18n.t(`populationSize.${size}`, {
				ns: "ui",
				defaultValue: size,
			});

			return (
				<span className={className}>
					{i18n.t("popText.population", {
						ns: "ui",
						defaultValue: "Population:",
					})}{" "}
					{t.pop !== undefined ? (
						<>
							{i18n.t("popText.million", {
								ns: "ui",
								defaultValue: "{{pop}} million",
								pop: t.pop.toFixed(1),
							})}{" "}
						</>
					) : (
						""
					)}
					(
					{i18n.t(
						marketRankTied ? "popText.marketRankTied" : "popText.marketRank",
						{
							ns: "ui",
							defaultValue: marketRankTied
								? "tied for rank {{rank}} by market size, {{total}} teams total, {{size}}"
								: "ranked {{rank}} by market size, {{total}} teams total, {{size}}",
							rank: marketRank,
							size: sizeText,
							total: numActiveTeams,
						},
					)}
					)<br />
				</span>
			);
		}
	}

	return (
		<span className={className}>
			{i18n.t("popText.populationUnknown", {
				ns: "ui",
				defaultValue: "Population: ?",
			})}
		</span>
	);
};
